var exports = {
  "container": "xaee3c4fa--8ef956--container",
  "text-block": "xaee3c4fa--8ef956--text-block",
  "form": "xaee3c4fa--8ef956--form",
  "button-wrapper": "xaee3c4fa--8ef956--button-wrapper",
  "phone": "xaee3c4fa--8ef956--phone",
};

module.exports = exports;
